/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ProductMetadata
 */
export interface ProductMetadata {
    /**
     *
     * @type {string}
     * @memberof ProductMetadata
     */
    stripeId: string;
    /**
     *
     * @type {string}
     * @memberof ProductMetadata
     */
    slug: string;
    /**
     *
     * @type {string}
     * @memberof ProductMetadata
     */
    name: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ProductMetadata
     */
    features: Array<string>;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof ProductMetadata
     */
    priceDisplays: { [key: string]: string; };
    /**
     *
     * @type {string}
     * @memberof ProductMetadata
     */
    description: string;
    /**
     *
     * @type {boolean}
     * @memberof ProductMetadata
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the ProductMetadata interface.
 */
export function instanceOfProductMetadata(value: object): value is ProductMetadata {
    if (!('stripeId' in value) || value['stripeId'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    if (!('priceDisplays' in value) || value['priceDisplays'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function ProductMetadataFromJSON(json: any): ProductMetadata {
    return ProductMetadataFromJSONTyped(json, false);
}

export function ProductMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductMetadata {
    if (json == null) {
        return json;
    }
    return {

        'stripeId': json['stripe_id'],
        'slug': json['slug'],
        'name': json['name'],
        'features': json['features'],
        'priceDisplays': json['price_displays'],
        'description': json['description'],
        'isDefault': json['is_default'],
    };
}

  export function ProductMetadataToJSON(json: any): ProductMetadata {
      return ProductMetadataToJSONTyped(json, false);
  }

  export function ProductMetadataToJSONTyped(value?: ProductMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'stripe_id': value['stripeId'],
        'slug': value['slug'],
        'name': value['name'],
        'features': value['features'],
        'price_displays': value['priceDisplays'],
        'description': value['description'],
        'is_default': value['isDefault'],
    };
}
